<div class="container gbr-container">
  <div
    class="close-button"
    (click)="close()">
    <mat-icon>close</mat-icon>
  </div>
  <div class="content">
    <div class="header">
      <h3 class="header-text">{{ 'gbr.request-header' | translate }}</h3>

      @if (existingTravelRequest?.requestState) {
        <div class="coin-chip-info">
          <p class="title">
            {{ 'gbr.state-' + existingTravelRequest.requestState | translate }}
          </p>
          <p class="value">
            {{ existingTravelRequest.updatedAt | date: 'dd.MM.yyyy' }}
          </p>
        </div>
      }

      @if (existingTravelRequest?.isEditedByAdmin) {
        <div class="coin-chip-info">
          <p class="title">
            {{ 'gbr.admin-edit' | translate }}
          </p>
          <p class="value">
            {{ existingTravelRequest?.adminEditDate | date: 'dd.MM.yyyy' }}
          </p>
        </div>
      }

      <coin-simple-lang-switch [includedLangs]="['de', 'en']"></coin-simple-lang-switch>
    </div>

    @if (loading) {
      <div class="loading">
        <v2-turbine></v2-turbine>
      </div>
    } @else {
      <div class="main-content">
        <div class="coin-stepper-container">
          <div class="split-view">
            <div class="last-inputs personal-data">
              <div class="profile-infos">
                <coin-siemens-energy-personal-data [employee]="employeeData"></coin-siemens-energy-personal-data>
              </div>
            </div>

            <div class="new-inputs">
              <mat-horizontal-stepper #stepper>
                <form [formGroup]="travelPersons">
                  <div class="new-inputs">
                    <mat-step
                      [completed]="wasRequestSubmitted"
                      [label]="'gbr.overview.step-personal' | translate">
                      <div class="new-inputs">
                        <div class="scroll">
                          <div class="text-container title-part">
                            <h4>
                              {{ 'gbr.overview.step-personal' | translate | uppercase }}
                            </h4>
                            <p>
                              {{ 'gbr.overview.step-personal-description' | translate }}
                            </p>
                          </div>
                          <div
                            class="content-part grid-inputs"
                            formGroupName="personalInfos">
                            <coin-simple-gbr-input
                              formControlName="isSingleParent"
                              [label]="'gbr.personal-infos.single-parent' | translate"
                              [infoText]="'gbr.personal-infos.single-parent-info' | translate"
                              [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
                            <coin-simple-gbr-input
                              formControlName="isShiftWorker"
                              [label]="'gbr.personal-infos.change-shift' | translate"
                              [infoText]="'gbr.personal-infos.shift-work-info' | translate"
                              [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
                            <coin-simple-gbr-input
                              formControlName="email"
                              [labelTooltip]="'gbr.tooltip.email' | translate"
                              [label]="'gbr.personal-infos.email' | translate"
                              [type]="simpleInputTypes.Text"></coin-simple-gbr-input>
                            <coin-simple-gbr-input
                              formControlName="hasParentLeave"
                              [labelTooltip]="'gbr.tooltip.parent-leave' | translate"
                              [label]="'gbr.personal-infos.parent-leave' | translate"
                              [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
                            <coin-simple-gbr-input
                              formControlName="hasDisabilities"
                              [label]="'gbr.personal-infos.disability' | translate"
                              [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
                            <coin-simple-gbr-input
                              formControlName="hasCare"
                              [labelTooltip]="'gbr.tooltip.care' | translate"
                              [infoText]="'gbr.personal-infos.care-info' | translate"
                              [label]="'gbr.personal-infos.care' | translate"
                              [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
                          </div>
                        </div>
                      </div>
                    </mat-step>
                  </div>

                  <mat-step
                    [completed]="wasRequestSubmitted"
                    [label]="'gbr.overview.step-vacation' | translate">
                    <div class="split-view">
                      <div class="last-inputs">
                        <div class="scroll">
                          <coin-siemens-energy-input-overview
                            [values]="travelPersons"
                            [stepIndex]="1"></coin-siemens-energy-input-overview>
                        </div>
                      </div>
                      <div class="new-inputs">
                        <div class="scroll">
                          <div class="text-container title-part">
                            <h4>
                              {{ 'gbr.overview.step-vacation' | translate | uppercase }}
                            </h4>
                            <p>
                              {{ 'gbr.overview.step-vacation-description' | translate }}
                            </p>
                          </div>
                          <div
                            class="content-part grid-inputs"
                            formGroupName="vacation">
                            <coin-simple-gbr-input
                              formControlName="country"
                              [label]="('gbr.vacation.country' | translate) + '*'"
                              [type]="simpleInputTypes.Dropdown"
                              [options]="countries"></coin-simple-gbr-input>
                            <coin-simple-gbr-input
                              formControlName="period"
                              [labelTooltip]="'gbr.tooltip.period' | translate"
                              [label]="('gbr.vacation.period' | translate) + '*'"
                              [minDate]="minVacationDate"
                              [maxDate]="maxVacationDate"
                              [type]="simpleInputTypes.DateRange"></coin-simple-gbr-input>
                            @if (isInvalidPeriod) {
                              <p></p>
                              <p class="short-period">{{ 'gbr.period-too-short' | translate }}</p>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step
                    [completed]="wasRequestSubmitted"
                    [label]="'gbr.overview.step-spouse' | translate">
                    <div class="split-view">
                      <div class="last-inputs">
                        <div class="scroll">
                          <coin-siemens-energy-input-overview
                            [values]="travelPersons"
                            [stepIndex]="2"></coin-siemens-energy-input-overview>
                        </div>
                      </div>
                      <div class="new-inputs">
                        <div class="travel-person-wrapper">
                          <div class="scroll">
                            <div class="text-container title-part">
                              <h4>
                                {{ 'gbr.overview.partner-title' | translate }}
                              </h4>
                              <p>
                                {{ 'gbr.overview.partner-add-info' | translate }}
                              </p>
                            </div>
                            <div class="content-part">
                              <div class="input-wrapper">
                                <coin-siemens-energy-person-input
                                  formControlName="spouse"
                                  [type]="personTypes.Spouse"
                                  (remove)="removeSpouse()"></coin-siemens-energy-person-input>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step
                    [completed]="wasRequestSubmitted"
                    [label]="'gbr.overview.step-children' | translate">
                    <div class="split-view">
                      <div class="last-inputs">
                        <div class="scroll">
                          <coin-siemens-energy-input-overview
                            [values]="travelPersons"
                            [stepIndex]="3"></coin-siemens-energy-input-overview>
                        </div>
                      </div>
                      <div class="new-inputs">
                        <div class="scroll">
                          <div class="text-container title-part">
                            <h4>
                              {{ 'gbr.overview.step-children' | translate | uppercase }}
                            </h4>
                            <p>
                              {{ 'gbr.overview.step-children-description' | translate }}
                            </p>
                          </div>
                          <div class="content-part">
                            <div
                              class="input-wrapper last-input"
                              formArrayName="children">
                              @for (child of children.controls; track child; let i = $index) {
                                <div class="input">
                                  <coin-siemens-energy-person-input
                                    [formControlName]="i"
                                    [type]="personTypes.Child"
                                    (remove)="removeChild(i)"></coin-siemens-energy-person-input>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step
                    [completed]="wasRequestSubmitted"
                    [label]="('gbr.overview.step-files' | translate) + '*'">
                    <div class="split-view">
                      <div class="last-inputs">
                        <div class="scroll">
                          <coin-siemens-energy-input-overview
                            [values]="travelPersons"
                            [stepIndex]="4"></coin-siemens-energy-input-overview>
                        </div>
                      </div>
                      <div class="new-inputs">
                        <div class="scroll">
                          <div class="text-container title-part">
                            <h4>
                              {{ 'gbr.overview.invoice-title' | translate | uppercase }}
                              *
                            </h4>
                            <p>
                              {{ 'gbr.overview.step-files-description' | translate }}
                            </p>
                          </div>
                          <div class="content-part">
                            <div
                              class="input-wrapper last-input"
                              formArrayName="files">
                              @for (file of files.controls; track file; let i = $index) {
                                <div class="input">
                                  <coin-siemens-energy-file-input
                                    [formControlName]="i"
                                    (delete)="deleteFile(i)"></coin-siemens-energy-file-input>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-step>
                </form>
              </mat-horizontal-stepper>
            </div>
          </div>
        </div>
      </div>
    }

    <ng-template #content>
      <div class="main-content">
        <div class="coin-stepper-container">
          <div class="split-view">
            <div class="last-inputs personal-data">
              <div class="profile-infos">
                <coin-siemens-energy-personal-data [employee]="employeeData"></coin-siemens-energy-personal-data>
              </div>
            </div>

            <div class="new-inputs">
              <mat-horizontal-stepper #stepper>
                <form [formGroup]="travelPersons">
                  <div class="new-inputs">
                    <mat-step
                      [completed]="wasRequestSubmitted"
                      [label]="'gbr.overview.step-personal' | translate">
                      <div class="new-inputs">
                        <div class="scroll">
                          <div class="text-container title-part">
                            <h4>
                              {{ 'gbr.overview.step-personal' | translate | uppercase }}
                            </h4>
                            <p>
                              {{ 'gbr.overview.step-personal-description' | translate }}
                            </p>
                          </div>
                          <div
                            class="content-part grid-inputs"
                            formGroupName="personalInfos">
                            <coin-simple-gbr-input
                              formControlName="isSingleParent"
                              [label]="'gbr.personal-infos.single-parent' | translate"
                              [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
                            <coin-simple-gbr-input
                              formControlName="isShiftWorker"
                              [label]="'gbr.personal-infos.change-shift' | translate"
                              [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
                            <coin-simple-gbr-input
                              formControlName="email"
                              [labelTooltip]="'gbr.tooltip.email' | translate"
                              [label]="'gbr.personal-infos.email' | translate"
                              [type]="simpleInputTypes.Text"></coin-simple-gbr-input>
                            <coin-simple-gbr-input
                              formControlName="hasParentLeave"
                              [labelTooltip]="'gbr.tooltip.parent-leave' | translate"
                              [label]="'gbr.personal-infos.parent-leave' | translate"
                              [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
                            <coin-simple-gbr-input
                              formControlName="hasDisabilities"
                              [label]="'gbr.personal-infos.disability' | translate"
                              [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
                            <coin-simple-gbr-input
                              formControlName="hasCare"
                              [labelTooltip]="'gbr.tooltip.care' | translate"
                              [label]="'gbr.personal-infos.care' | translate"
                              [type]="simpleInputTypes.YesNo"></coin-simple-gbr-input>
                          </div>
                        </div>
                      </div>
                    </mat-step>
                  </div>

                  <mat-step
                    [completed]="wasRequestSubmitted"
                    [label]="'gbr.overview.step-vacation' | translate">
                    <div class="split-view">
                      <div class="last-inputs">
                        <div class="scroll">
                          <coin-siemens-energy-input-overview
                            [values]="travelPersons"
                            [stepIndex]="1"></coin-siemens-energy-input-overview>
                        </div>
                      </div>
                      <div class="new-inputs">
                        <div class="scroll">
                          <div class="text-container title-part">
                            <h4>
                              {{ 'gbr.overview.step-vacation' | translate | uppercase }}
                            </h4>
                            <p>
                              {{ 'gbr.overview.step-vacation-description' | translate }}
                            </p>
                          </div>
                          <div
                            class="content-part grid-inputs"
                            formGroupName="vacation">
                            <coin-simple-gbr-input
                              formControlName="country"
                              [label]="('gbr.vacation.country' | translate) + '*'"
                              [type]="simpleInputTypes.Dropdown"
                              [options]="countries"></coin-simple-gbr-input>
                            <coin-simple-gbr-input
                              formControlName="period"
                              [labelTooltip]="'gbr.tooltip.period' | translate"
                              [label]="('gbr.vacation.period' | translate) + '*'"
                              [minDate]="minVacationDate"
                              [maxDate]="maxVacationDate"
                              [type]="simpleInputTypes.DateRange"></coin-simple-gbr-input>
                            @if (isInvalidPeriod) {
                              <p></p>
                              <p class="short-period">{{ 'gbr.period-too-short' | translate }}</p>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step
                    [completed]="wasRequestSubmitted"
                    [label]="'gbr.overview.step-spouse' | translate">
                    <div class="split-view">
                      <div class="last-inputs">
                        <div class="scroll">
                          <coin-siemens-energy-input-overview
                            [values]="travelPersons"
                            [stepIndex]="2"></coin-siemens-energy-input-overview>
                        </div>
                      </div>
                      <div class="new-inputs">
                        <div class="travel-person-wrapper">
                          <div class="scroll">
                            <div class="text-container title-part">
                              <h4>
                                {{ 'gbr.overview.partner-title' | translate }}
                              </h4>
                              <p>
                                {{ 'gbr.overview.partner-add-info' | translate }}
                              </p>
                            </div>
                            <div class="content-part">
                              <div class="input-wrapper">
                                <coin-siemens-energy-person-input
                                  formControlName="spouse"
                                  [type]="personTypes.Spouse"
                                  (remove)="removeSpouse()"></coin-siemens-energy-person-input>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step
                    [completed]="wasRequestSubmitted"
                    [label]="'gbr.overview.step-children' | translate">
                    <div class="split-view">
                      <div class="last-inputs">
                        <div class="scroll">
                          <coin-siemens-energy-input-overview
                            [values]="travelPersons"
                            [stepIndex]="3"></coin-siemens-energy-input-overview>
                        </div>
                      </div>
                      <div class="new-inputs">
                        <div class="scroll">
                          <div class="text-container title-part">
                            <h4>
                              {{ 'gbr.overview.step-children' | translate | uppercase }}
                            </h4>
                            <p>
                              {{ 'gbr.overview.step-children-description' | translate }}
                            </p>
                          </div>
                          <div class="content-part">
                            <div
                              class="input-wrapper last-input"
                              formArrayName="children">
                              @for (child of children.controls; track child; let i = $index) {
                                <div class="input">
                                  <coin-siemens-energy-person-input
                                    [formControlName]="i"
                                    [type]="personTypes.Child"
                                    (remove)="removeChild(i)"></coin-siemens-energy-person-input>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step
                    [completed]="wasRequestSubmitted"
                    [label]="('gbr.overview.step-files' | translate) + '*'">
                    <div class="split-view">
                      <div class="last-inputs">
                        <div class="scroll">
                          <coin-siemens-energy-input-overview
                            [values]="travelPersons"
                            [stepIndex]="4"></coin-siemens-energy-input-overview>
                        </div>
                      </div>
                      <div class="new-inputs">
                        <div class="scroll">
                          <div class="text-container title-part">
                            <h4>
                              {{ 'gbr.overview.invoice-title' | translate | uppercase }}
                              *
                            </h4>
                            <p>
                              {{ 'gbr.overview.step-files-description' | translate }}
                            </p>
                          </div>
                          <div class="content-part">
                            <div
                              class="input-wrapper last-input"
                              formArrayName="files">
                              @for (file of files.controls; track file; let i = $index) {
                                <div class="input">
                                  <coin-siemens-energy-file-input
                                    [formControlName]="i"
                                    (delete)="deleteFile(i)"></coin-siemens-energy-file-input>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-step>
                </form>
              </mat-horizontal-stepper>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="buttons">
      @if (existingTravelRequest?.id) {
        <coin-v2-button
          [type]="'secondary'"
          [text]="'gbr.delete' | translate"
          [disabled]="cannotDelete"
          (click)="delete()"></coin-v2-button>
        <coin-v2-divider
          class="divider"
          orientation="vertical" />
      }
      @if (wasRequestSubmitted) {
        <mat-icon
          class="icon-info-gbr green-icon"
          [matTooltip]="
            ('gbr.tooltip.submit-successful' | translate) +
            ' (' +
            (existingTravelRequest?.updatedAt | date: 'MM/dd/yyyy') +
            ')'
          ">
          check_circle
        </mat-icon>
      }
      @if (!data.isAdmin) {
        <coin-v2-button
          [type]="'primary'"
          [text]="'gbr.submit' | translate"
          [disabled]="!isFormValid"
          (click)="submit()"></coin-v2-button>
      }
      <coin-v2-button
        [type]="'secondary'"
        [text]="'gbr.save' | translate"
        [disabled]="travelPersons.disabled || !isFormValid"
        (click)="save()"></coin-v2-button>
      <coin-v2-divider
        class="divider"
        orientation="vertical" />
      @if (hasPreviousStep) {
        <coin-v2-button
          [type]="'primary'"
          [icon]="'chevron_left'"
          [text]="'gbr.previous-step' | translate"
          (click)="previous()"></coin-v2-button>
      }
      @if (hasNextStep) {
        <coin-v2-button
          [type]="'primary'"
          [icon]="'chevron_right'"
          [iconPos]="'right'"
          [text]="'gbr.next-step' | translate"
          (click)="next()"></coin-v2-button>
      }
    </div>
  </div>
</div>
